import React, { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { Modal, Field, Badge, Spinner, Tabs, Confirm } from "../components/ui";
import { ListesValeurs } from "./ParametrageListes";

function Produits() {
  const [produits, setProduits] = useState<any[] | null>(null);
  const [edit, setEdit] = useState<any>(null);
  const [del, setDel] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  const load = () => api.get("/produits").then((r) => setProduits(r.data));
  useEffect(() => {
    load();
  }, []);
  if (!produits) return <Spinner />;
  const save = async () => {
    setErr(null);
    const body = { ...edit, sous_produits: (edit.sous_produits_str || "").split(",").map((s: string) => s.trim()).filter(Boolean) };
    try {
      if (edit.id) await api.patch(`/produits/${edit.id}`, body);
      else await api.post("/produits", body);
      setEdit(null);
      load();
    } catch (e) {
      setErr(apiError(e));
    }
  };
  return (
    <div className="nx-card overflow-x-auto">
      <div className="flex items-center justify-between border-b border-line p-3">
        <h2 className="text-sm font-bold text-green">Catalogue produits</h2>
        <button data-testid="produit-add-btn" className="nx-btn-primary !px-2.5 !py-1 text-xs" onClick={() => setEdit({ modele: "contrat" })}>Ajouter</button>
      </div>
      <table className="nx-table">
        <thead><tr><th>Nom</th><th>Remise éditeur</th><th>Modèle</th><th>Sous-produits</th><th className="text-right">Actions</th></tr></thead>
        <tbody>
          {produits.map((p) => (
            <tr key={p.id} data-testid={`produit-row-${p.nom}`}>
              <td className="font-semibold">{p.nom}</td>
              <td>{p.remise_editeur || "—"}</td>
              <td><Badge>{p.modele}</Badge></td>
              <td className="space-x-1">{(p.sous_produits || []).map((sp: any) => <Badge key={sp.id} className="bg-lime-soft text-green">{sp.nom}</Badge>)}</td>
              <td className="text-right">
                <div className="flex justify-end gap-1.5">
                  <button data-testid={`produit-edit-btn-${p.nom}`} className="nx-btn-ghost !px-2 !py-1 text-xs" onClick={() => setEdit({ ...p, sous_produits_str: (p.sous_produits || []).map((s: any) => s.nom).join(", ") })}>Éditer</button>
                  <button data-testid={`produit-delete-btn-${p.nom}`} className="nx-btn-danger !px-2 !py-1 text-xs" onClick={() => setDel(p)}>Supprimer</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {edit && (
        <Modal title={edit.id ? `Produit — ${edit.nom}` : "Nouveau produit"} onClose={() => setEdit(null)} testId="produit-modal">
          <div className="space-y-3">
            <Field label="Nom">
              <input data-testid="produit-nom-input" className="nx-input" value={edit.nom || ""} onChange={(e) => setEdit({ ...edit, nom: e.target.value })} />
            </Field>
            <Field label="Remise éditeur">
              <input className="nx-input" value={edit.remise_editeur || ""} onChange={(e) => setEdit({ ...edit, remise_editeur: e.target.value })} placeholder="35%" />
            </Field>
            <Field label="Modèle">
              <select data-testid="produit-modele-select" className="nx-input" value={edit.modele} onChange={(e) => setEdit({ ...edit, modele: e.target.value })}>
                <option value="contrat">Contrat</option>
                <option value="consommation">Consommation</option>
                <option value="autre">Autre</option>
              </select>
            </Field>
            <Field label="Sous-produits (séparés par des virgules)">
              <input data-testid="produit-sousproduits-input" className="nx-input" value={edit.sous_produits_str || ""} onChange={(e) => setEdit({ ...edit, sous_produits_str: e.target.value })} placeholder="MF, MFS, Hive" />
            </Field>
            {err && <p className="text-sm text-danger">{err}</p>}
            <div className="flex justify-end gap-2">
              <button className="nx-btn-ghost" onClick={() => setEdit(null)}>Annuler</button>
              <button data-testid="produit-save-btn" className="nx-btn-primary" disabled={!edit.nom} onClick={save}>Enregistrer</button>
            </div>
          </div>
        </Modal>
      )}
      {del && <Confirm message={`Supprimer le produit « ${del.nom} » ?`} onConfirm={async () => { await api.delete(`/produits/${del.id}`); setDel(null); load(); }} onCancel={() => setDel(null)} />}
    </div>
  );
}

function ComptesBancaires({ entiteId, initial, onChanged }: { entiteId: string; initial: any[]; onChanged: () => void }) {
  const [rows, setRows] = useState<any[]>(() => (initial || []).map((b) => ({ ...b })));
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState<string | null>(null);
  const setField = (i: number, f: string, v: any) => setRows((rs) => rs.map((r, j) => (j === i ? { ...r, [f]: v } : r)));
  const add = () => setRows((rs) => [...rs, { devise: "EUR", titulaire: "", banque: "", iban: "", bic: "", _new: true }]);
  const save = async (i: number) => {
    setErr(null);
    setBusy(`s${i}`);
    try {
      const r = rows[i];
      const { data } = await api.put(`/entites/${entiteId}/banques`, { devise: r.devise, titulaire: r.titulaire, banque: r.banque, iban: r.iban, bic: r.bic });
      setRows((rs) => rs.map((x, j) => (j === i ? { ...data } : x)));
      onChanged();
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setBusy(null);
    }
  };
  const remove = async (i: number) => {
    const r = rows[i];
    if (r._new || !r.id) {
      setRows((rs) => rs.filter((_, j) => j !== i));
      return;
    }
    setErr(null);
    setBusy(`d${i}`);
    try {
      await api.delete(`/entites/${entiteId}/banques/${r.devise}`);
      setRows((rs) => rs.filter((_, j) => j !== i));
      onChanged();
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="col-span-2 border-t border-line pt-3" data-testid="comptes-bancaires">
      <div className="mb-1.5 flex items-center justify-between">
        <label className="nx-label !mb-0">Comptes bancaires (un par devise)</label>
        <button type="button" data-testid="banque-add-btn" className="nx-btn-ghost !px-2 !py-1 text-xs" onClick={add}>+ Ajouter un compte</button>
      </div>
      {rows.length === 0 && <p className="text-xs text-muted">Aucun compte bancaire.</p>}
      <div className="space-y-2">
        {rows.map((r, i) => (
          <div key={r.id || `new-${i}`} data-testid={`banque-row-${r.devise}`} className="rounded-lg border border-line bg-soft/40 p-2">
            <div className="grid grid-cols-6 gap-2">
              <select data-testid={`banque-devise-${i}`} className="nx-input" value={r.devise} onChange={(e) => setField(i, "devise", e.target.value)}>
                <option>EUR</option>
                <option>TND</option>
              </select>
              <input data-testid={`banque-titulaire-${i}`} className="nx-input col-span-2" placeholder="Titulaire" value={r.titulaire || ""} onChange={(e) => setField(i, "titulaire", e.target.value)} />
              <input data-testid={`banque-banque-${i}`} className="nx-input col-span-3" placeholder="Banque" value={r.banque || ""} onChange={(e) => setField(i, "banque", e.target.value)} />
              <input data-testid={`banque-iban-${i}`} className="nx-input col-span-4" placeholder="IBAN" value={r.iban || ""} onChange={(e) => setField(i, "iban", e.target.value)} />
              <input data-testid={`banque-bic-${i}`} className="nx-input col-span-2" placeholder="BIC" value={r.bic || ""} onChange={(e) => setField(i, "bic", e.target.value)} />
            </div>
            <div className="mt-1.5 flex justify-end gap-2">
              <button type="button" data-testid={`banque-delete-${i}`} className="nx-btn-ghost !px-2 !py-1 text-xs text-danger" disabled={busy === `d${i}`} onClick={() => remove(i)}>Supprimer</button>
              <button type="button" data-testid={`banque-save-${i}`} className="nx-btn-primary !px-2.5 !py-1 text-xs" disabled={busy === `s${i}`} onClick={() => save(i)}>{busy === `s${i}` ? "…" : "Enregistrer"}</button>
            </div>
          </div>
        ))}
      </div>
      {err && <p className="mt-2 rounded-lg bg-red-50 px-3 py-2 text-sm text-danger" data-testid="banque-error">{err}</p>}
    </div>
  );
}

function Entites() {
  const [entites, setEntites] = useState<any[] | null>(null);
  const [edit, setEdit] = useState<any>(null);
  const load = () => api.get("/entites").then((r) => setEntites(r.data));
  useEffect(() => {
    load();
  }, []);
  if (!entites) return <Spinner />;
  return (
    <div className="space-y-3">
      {entites.map((e) => (
        <div key={e.id} className="nx-card p-4" data-testid={`entite-card-${e.code}`}>
          <div className="flex flex-wrap items-center gap-2">
            <Badge className="bg-green text-white">{e.code}</Badge>
            <span className="font-bold">{e.nom}</span>
            <span className="text-sm text-muted">{e.forme} · Capital {e.capital}</span>
            {e.confidentiel && <Badge className="bg-red-50 text-danger">Confidentielle</Badge>}
            <Badge className="bg-soft text-muted">Gabarit : {e.template}</Badge>
            <button data-testid={`entite-edit-btn-${e.code}`} className="nx-btn-ghost ml-auto !px-2.5 !py-1 text-xs" onClick={() => setEdit({ ...e, adresse_str: (e.adresse || []).join("\n"), mentions_str: (e.mentions || []).join("\n") })}>Éditer</button>
          </div>
          <p className="mt-1 text-sm text-muted">{(e.adresse || []).join(", ")} {e.telephone && `· ${e.telephone}`} · {e.email}</p>
          <p className="text-xs text-muted">{e.identifiants_fiscaux}</p>
          <div className="mt-2 flex flex-wrap gap-2">
            {(e.banques || []).map((b: any) => (
              <span key={b.id} data-testid={`banque-chip-${e.code}-${b.devise}`} className="rounded-lg border border-line bg-soft px-3 py-1.5 text-xs">
                <b>{b.devise}</b> · {b.banque} · {b.iban}
              </span>
            ))}
            {(e.banques || []).length === 0 && <span className="text-xs text-muted">Aucun compte bancaire</span>}
          </div>
        </div>
      ))}
      {edit && (
        <Modal title={`Entité ${edit.code}`} onClose={() => setEdit(null)} wide testId="entite-modal">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Raison sociale"><input className="nx-input" value={edit.nom || ""} onChange={(e) => setEdit({ ...edit, nom: e.target.value })} /></Field>
            <Field label="Forme"><input className="nx-input" value={edit.forme || ""} onChange={(e) => setEdit({ ...edit, forme: e.target.value })} /></Field>
            <Field label="Capital"><input className="nx-input" value={edit.capital || ""} onChange={(e) => setEdit({ ...edit, capital: e.target.value })} /></Field>
            <Field label="Téléphone"><input className="nx-input" value={edit.telephone || ""} onChange={(e) => setEdit({ ...edit, telephone: e.target.value })} /></Field>
            <Field label="Email"><input className="nx-input" value={edit.email || ""} onChange={(e) => setEdit({ ...edit, email: e.target.value })} /></Field>
            <Field label="Web"><input className="nx-input" value={edit.web || ""} onChange={(e) => setEdit({ ...edit, web: e.target.value })} /></Field>
            <Field label="Adresse (une ligne par ligne)" className="col-span-2">
              <textarea className="nx-input" rows={2} value={edit.adresse_str} onChange={(e) => setEdit({ ...edit, adresse_str: e.target.value })} />
            </Field>
            <Field label="Identifiants fiscaux" className="col-span-2">
              <input className="nx-input" value={edit.identifiants_fiscaux || ""} onChange={(e) => setEdit({ ...edit, identifiants_fiscaux: e.target.value })} />
            </Field>
            <Field label="Mentions légales (une par ligne)" className="col-span-2">
              <textarea className="nx-input" rows={2} value={edit.mentions_str} onChange={(e) => setEdit({ ...edit, mentions_str: e.target.value })} />
            </Field>
            <ComptesBancaires entiteId={edit.id} initial={edit.banques} onChanged={load} />
          </div>
          <div className="mt-4 flex justify-end gap-2">
            <button className="nx-btn-ghost" onClick={() => setEdit(null)}>Fermer</button>
            <button
              data-testid="entite-save-btn"
              className="nx-btn-primary"
              onClick={async () => {
                await api.patch(`/entites/${edit.id}`, {
                  ...edit,
                  adresse: edit.adresse_str.split("\n").filter(Boolean),
                  mentions: edit.mentions_str.split("\n").filter(Boolean),
                });
                setEdit(null);
                load();
              }}
            >
              Enregistrer les informations
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}

function Grille() {
  const [grille, setGrille] = useState<any[] | null>(null);
  const [sla, setSla] = useState<any[]>([]);
  const load = () => {
    api.get("/kpax-grille").then((r) => setGrille(r.data));
    api.get("/sla").then((r) => setSla(r.data));
  };
  useEffect(() => {
    load();
  }, []);
  if (!grille) return <Spinner />;
  const saveGrille = async (lignes: any[]) => {
    const { data } = await api.put("/kpax-grille", { lignes });
    setGrille(data);
  };
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div className="nx-card p-4">
        <h2 className="mb-2 text-sm font-bold text-green">Grille tarifaire KPAX</h2>
        <div className="space-y-1.5">
          {grille.map((g, i) => (
            <div key={g.id || i} className="flex items-center gap-2" data-testid={`grille-row-${i}`}>
              <span className="w-16 text-xs text-muted">{g.plafond === null ? "Au-delà" : "Jusqu'à"}</span>
              <input
                data-testid={`grille-plafond-${i}`}
                type="number"
                className="nx-input w-28"
                value={g.plafond ?? ""}
                placeholder="∞"
                onChange={(e) => setGrille(grille.map((x, xi) => (xi === i ? { ...x, plafond: e.target.value === "" ? null : +e.target.value } : x)))}
              />
              <input
                data-testid={`grille-tarif-${i}`}
                type="number"
                step="0.001"
                className="nx-input w-24"
                value={g.tarif}
                onChange={(e) => setGrille(grille.map((x, xi) => (xi === i ? { ...x, tarif: +e.target.value } : x)))}
              />
              <button className="text-danger" onClick={() => setGrille(grille.filter((_, xi) => xi !== i))}>✕</button>
            </div>
          ))}
        </div>
        <div className="mt-3 flex gap-2">
          <button className="nx-btn-ghost !px-2.5 !py-1 text-xs" onClick={() => setGrille([...grille, { plafond: null, tarif: 0 }])}>+ Palier</button>
          <button data-testid="grille-save-btn" className="nx-btn-primary !px-2.5 !py-1 text-xs" onClick={() => saveGrille(grille)}>Enregistrer la grille</button>
        </div>
      </div>
      <div className="nx-card p-4">
        <h2 className="mb-2 text-sm font-bold text-green">Seuils SLA par priorité</h2>
        <div className="space-y-1.5">
          {sla.map((s) => (
            <div key={s.priorite} className="flex items-center gap-2">
              <Badge className={s.priorite === "P1" ? "bg-red-50 text-danger" : "bg-soft text-green"}>{s.priorite}</Badge>
              <input
                data-testid={`sla-input-${s.priorite}`}
                type="number"
                className="nx-input w-24"
                value={s.heures}
                onChange={(e) => setSla(sla.map((x) => (x.priorite === s.priorite ? { ...x, heures: +e.target.value } : x)))}
              />
              <span className="text-sm text-muted">heures</span>
              <button
                data-testid={`sla-save-btn-${s.priorite}`}
                className="nx-btn-ghost !px-2 !py-1 text-xs"
                onClick={async () => {
                  await api.put("/sla", { priorite: s.priorite, heures: s.heures });
                }}
              >
                Enregistrer
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Taux() {
  const [taux, setTaux] = useState<any[] | null>(null);
  const [form, setForm] = useState<any>({ devise_source: "EUR", devise_cible: "TND", taux: "", date: "" });
  const [err, setErr] = useState<string | null>(null);
  const load = () => api.get("/taux-change").then((r) => setTaux(r.data));
  useEffect(() => {
    load();
  }, []);
  if (!taux) return <Spinner />;
  const save = async () => {
    setErr(null);
    try {
      await api.post("/taux-change", { ...form, taux: +form.taux, date: form.date || null });
      setForm({ ...form, taux: "", date: "" });
      load();
    } catch (e) {
      setErr(apiError(e));
    }
  };
  return (
    <div className="nx-card max-w-2xl p-4">
      <h2 className="mb-1 text-sm font-bold text-green">Taux de change EUR → TND</h2>
      <p className="mb-3 text-xs text-muted">Le taux le plus récent est appliqué automatiquement aux nouveaux devis et bons de commande en TND. L'historique est conservé par date.</p>
      <div className="flex flex-wrap items-end gap-2">
        <Field label="Taux (1 EUR =)">
          <input data-testid="taux-input" type="number" step="0.0001" min="0" className="nx-input w-32" value={form.taux} onChange={(e) => setForm({ ...form, taux: e.target.value })} />
        </Field>
        <Field label="Date (défaut : aujourd'hui)">
          <input data-testid="taux-date-input" type="date" className="nx-input w-40" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
        </Field>
        <button data-testid="taux-save-btn" className="nx-btn-primary" disabled={!form.taux || +form.taux <= 0} onClick={save}>Ajouter</button>
      </div>
      {err && <p className="mt-2 text-sm text-danger" data-testid="taux-error">{err}</p>}
      <table className="nx-table mt-4">
        <thead><tr><th>Date</th><th>Source</th><th>Cible</th><th className="text-right">Taux</th></tr></thead>
        <tbody>
          {taux.map((t, i) => (
            <tr key={t.id} data-testid={`taux-row-${i}`} className={i === 0 ? "font-semibold" : ""}>
              <td>{t.date}</td>
              <td>{t.devise_source}</td>
              <td>{t.devise_cible}</td>
              <td className="text-right">{t.taux} {i === 0 && <Badge className="ml-1 bg-lime-soft text-green">courant</Badge>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function statutBadge(u: any) {
  if (u.statut_compte === "invite") return <Badge className="bg-amber-50 text-amber" testId={`user-statut-${u.email}`}>Invité</Badge>;
  return <Badge className="bg-lime-soft text-green" testId={`user-statut-${u.email}`}>Actif</Badge>;
}

function InvitationBox({ invite, onClose }: { invite: any; onClose: () => void }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(invite.lien_activation);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };
  return (
    <Modal title={`Invitation — ${invite.email}`} onClose={onClose} testId="invitation-modal">
      {invite.error ? (
        <p className="text-sm text-danger" data-testid="invitation-error">{invite.error}</p>
      ) : invite.email_envoye ? (
        <p className="text-sm text-ink" data-testid="invitation-sent">
          Un email d'invitation a été envoyé à <b>{invite.email}</b>. Le lien d'activation expire dans 72 heures.
        </p>
      ) : (
        <div className="space-y-3">
          <p className="rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber" data-testid="invitation-manual">
            Envoi d'email non configuré (Resend). Transmettez ce lien d'activation à l'utilisateur pour qu'il définisse son mot de passe. Il expire dans 72&nbsp;heures et n'est utilisable qu'une fois.
          </p>
          <div className="flex items-center gap-2">
            <input data-testid="invitation-link-input" readOnly className="nx-input text-xs" value={invite.lien_activation} onFocus={(e) => e.target.select()} />
            <button data-testid="invitation-copy-btn" className="nx-btn-primary !px-2.5 !py-1 text-xs whitespace-nowrap" onClick={copy}>
              {copied ? "Copié !" : "Copier"}
            </button>
          </div>
        </div>
      )}
      <div className="mt-4 flex justify-end">
        <button className="nx-btn-ghost" data-testid="invitation-close-btn" onClick={onClose}>Fermer</button>
      </div>
    </Modal>
  );
}

function Users() {
  const [users, setUsers] = useState<any[] | null>(null);
  const [edit, setEdit] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  const [invite, setInvite] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => {
    load();
  }, []);
  if (!users) return <Spinner />;
  const save = async () => {
    setErr(null);
    setBusy(true);
    try {
      if (edit.id) {
        await api.patch(`/users/${edit.id}`, edit);
        setEdit(null);
      } else {
        const { data } = await api.post("/users", edit);
        setEdit(null);
        setInvite({ email: data.email, ...(data.invitation || {}) });
      }
      load();
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setBusy(false);
    }
  };
  const renvoyer = async (u: any) => {
    try {
      const { data } = await api.post(`/users/${u.id}/invite`);
      setInvite({ email: u.email, ...data });
      load();
    } catch (e) {
      setInvite({ email: u.email, error: apiError(e) });
    }
  };
  const reinitialiser = async (u: any) => {
    try {
      const { data } = await api.post(`/users/${u.id}/reset-password`);
      if (data.email_envoye) alert(`Un lien de réinitialisation du mot de passe a été envoyé à ${u.email}. Il expire dans 1 heure.`);
      else alert(`Lien de réinitialisation à transmettre à ${u.email} (valable 1 heure) :\n\n${data.lien_reset}`);
      load();
    } catch (e) {
      alert(apiError(e));
    }
  };
  return (
    <div className="nx-card overflow-x-auto">
      <div className="flex items-center justify-between border-b border-line p-3">
        <h2 className="text-sm font-bold text-green">Utilisateurs</h2>
        <button data-testid="user-add-btn" className="nx-btn-primary !px-2.5 !py-1 text-xs" onClick={() => setEdit({ role: "consultant", actif: true })}>Créer un utilisateur</button>
      </div>
      <table className="nx-table">
        <thead><tr><th>Nom</th><th>Email</th><th>Rôle</th><th>Statut</th><th>Actif</th><th className="text-right">Actions</th></tr></thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id} data-testid={`user-row-${u.email}`}>
              <td className="font-semibold">{u.nom_complet}</td>
              <td>{u.email}</td>
              <td><Badge className={u.role === "manager" ? "bg-green text-white" : "bg-soft text-green"}>{u.role}</Badge></td>
              <td>{statutBadge(u)}</td>
              <td>{u.actif ? "Oui" : "Non"}</td>
              <td className="text-right">
                <div className="flex justify-end gap-1.5">
                  {u.statut_compte === "invite" && (
                    <button data-testid={`user-resend-btn-${u.email}`} className="nx-btn-ghost !px-2 !py-1 text-xs" onClick={() => renvoyer(u)}>Renvoyer l'invitation</button>
                  )}
                  {u.statut_compte === "actif" && u.actif && (
                    <button data-testid={`user-reset-btn-${u.email}`} className="nx-btn-ghost !px-2 !py-1 text-xs" onClick={() => reinitialiser(u)}>Réinitialiser le mot de passe</button>
                  )}
                  <button data-testid={`user-edit-btn-${u.email}`} className="nx-btn-ghost !px-2 !py-1 text-xs" onClick={() => setEdit({ ...u })}>Éditer</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {edit && (
        <Modal title={edit.id ? `Utilisateur — ${edit.nom_complet}` : "Nouvel utilisateur"} onClose={() => setEdit(null)} testId="user-modal">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Nom complet">
              <input data-testid="user-nom-input" className="nx-input" value={edit.nom_complet || ""} onChange={(e) => setEdit({ ...edit, nom_complet: e.target.value })} />
            </Field>
            <Field label="Email">
              <input data-testid="user-email-input" className="nx-input" value={edit.email || ""} disabled={!!edit.id} onChange={(e) => setEdit({ ...edit, email: e.target.value })} />
            </Field>
            <Field label="Rôle">
              <select data-testid="user-role-select" className="nx-input" value={edit.role} onChange={(e) => setEdit({ ...edit, role: e.target.value })}>
                <option value="consultant">Consultant</option>
                <option value="manager">Manager</option>
              </select>
            </Field>
            <Field label="Initiales">
              <input className="nx-input" value={edit.initiales || ""} onChange={(e) => setEdit({ ...edit, initiales: e.target.value })} />
            </Field>
            <Field label="Actif">
              <select className="nx-input" value={edit.actif ? "1" : "0"} onChange={(e) => setEdit({ ...edit, actif: e.target.value === "1" })}>
                <option value="1">Oui</option>
                <option value="0">Non</option>
              </select>
            </Field>
          </div>
          {!edit.id && (
            <p className="mt-2 text-xs text-muted">
              Un email d'invitation sera envoyé pour que l'utilisateur définisse lui-même son mot de passe. Sans service d'email configuré, un lien d'activation à transmettre s'affichera.
            </p>
          )}
          {err && <p className="mt-2 text-sm text-danger" data-testid="user-form-error">{err}</p>}
          <div className="mt-4 flex justify-end gap-2">
            <button className="nx-btn-ghost" onClick={() => setEdit(null)}>Annuler</button>
            <button data-testid="user-save-btn" className="nx-btn-primary" disabled={!edit.nom_complet || !edit.email || busy} onClick={save}>
              {busy ? "Enregistrement…" : edit.id ? "Enregistrer" : "Créer et inviter"}
            </button>
          </div>
        </Modal>
      )}
      {invite && <InvitationBox invite={invite} onClose={() => setInvite(null)} />}
    </div>
  );
}

function Numerotation() {
  const [data, setData] = useState<any>(null);
  const [edit, setEdit] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  const load = () => api.get("/numerotation").then((r) => setData(r.data));
  useEffect(() => {
    load();
  }, []);
  if (!data) return <Spinner />;
  const save = async () => {
    setErr(null);
    try {
      await api.put(`/entites/${edit.id}/numerotation`, {
        facture_masque: (edit.facture_masque || "").trim() || null,
        dernier_numero: edit.dernier_numero === "" || edit.dernier_numero === undefined || edit.dernier_numero === null ? null : +edit.dernier_numero,
      });
      setEdit(null);
      load();
    } catch (e) {
      setErr(apiError(e));
    }
  };
  return (
    <div className="space-y-4" data-testid="numerotation-section">
      <div className="nx-card overflow-x-auto">
        <div className="border-b border-line p-3">
          <h2 className="text-sm font-bold text-green">Numérotation des factures (par entité)</h2>
          <p className="mt-1 text-xs text-muted">
            Masque&nbsp;: <code>AAAA</code> = année (séquence annuelle), <code>N…N</code> = séquence (largeur = nombre de N).
            Exemples&nbsp;: <code>NA-FA-NNNNNN</code>, <code>AAAA-NNNNNN</code>. Tant qu'aucun masque n'est renseigné, la génération de facture est bloquée.
          </p>
        </div>
        <table className="nx-table">
          <thead><tr><th>Entité</th><th>Masque</th><th>Dernier n°</th><th>Prochain n°</th><th className="text-right">Actions</th></tr></thead>
          <tbody>
            {data.factures.map((f: any) => (
              <tr key={f.id} data-testid={`num-row-${f.code}`}>
                <td className="font-semibold"><Badge className="bg-green text-white">{f.code}</Badge> <span className="ml-1">{f.nom}</span></td>
                <td>{f.configure ? <code>{f.facture_masque}</code> : <Badge className="bg-amber-50 text-amber">Non paramétré</Badge>}</td>
                <td>{f.configure ? f.dernier_numero : "—"}</td>
                <td className="font-semibold text-green" data-testid={`num-prochain-${f.code}`}>{f.configure ? f.prochain : "—"}</td>
                <td className="text-right">
                  <button data-testid={`num-edit-btn-${f.code}`} className="nx-btn-ghost !px-2 !py-1 text-xs" onClick={() => setEdit({ id: f.id, code: f.code, nom: f.nom, facture_masque: f.facture_masque || "", dernier_numero: f.configure ? f.dernier_numero : "" })}>Configurer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="nx-card p-4">
        <h2 className="text-sm font-bold text-green">Bons de commande (global, toutes entités)</h2>
        <p className="mt-1 text-sm text-muted">Format <code>BC-NNN</code> · dernier n° <b>{data.bc.dernier_numero}</b> · prochain <b className="text-green" data-testid="num-prochain-bc">{data.bc.prochain}</b></p>
      </div>
      {edit && (
        <Modal title={`Numérotation — ${edit.code} (${edit.nom})`} onClose={() => setEdit(null)} testId="num-modal">
          <div className="space-y-3">
            <Field label="Masque de numéro de facture">
              <input data-testid="num-masque-input" className="nx-input" value={edit.facture_masque} placeholder="ex. BMG-NNNNNN ou AAAA-NNNNNN" onChange={(e) => setEdit({ ...edit, facture_masque: e.target.value })} />
            </Field>
            <Field label="Dernier numéro (numéro de reprise ; laisser vide pour ne pas changer)">
              <input data-testid="num-dernier-input" type="number" min="0" className="nx-input w-40" value={edit.dernier_numero} onChange={(e) => setEdit({ ...edit, dernier_numero: e.target.value })} />
            </Field>
            <p className="text-xs text-muted">
              Le prochain numéro sera « dernier numéro + 1 ». Attention&nbsp;: modifier ces valeurs sur une entité déjà en production peut créer des doublons de numéro.
            </p>
            {err && <p className="text-sm text-danger" data-testid="num-error">{err}</p>}
            <div className="flex justify-end gap-2">
              <button className="nx-btn-ghost" onClick={() => setEdit(null)}>Annuler</button>
              <button data-testid="num-save-btn" className="nx-btn-primary" onClick={save}>Enregistrer</button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

function EmailCopie() {
  const [valeur, setValeur] = useState<string>("");
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    api.get("/parametres/email-copie").then((r) => {
      setValeur(r.data.email_copie_supervision || "");
      setLoaded(true);
    });
  }, []);
  const save = async () => {
    setBusy(true);
    setErr(null);
    setMsg(null);
    try {
      const { data } = await api.put("/parametres/email-copie", { valeur });
      setValeur(data.email_copie_supervision || "");
      setMsg("Adresse enregistrée");
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="nx-card max-w-xl p-4" data-testid="emails-section">
      <h2 className="mb-1 text-sm font-bold text-green">Copie des emails envoyés</h2>
      <p className="mb-3 text-xs text-muted">
        À chaque envoi d'un devis ou d'une proforma, une copie cachée (Cci) part à l'expéditeur ainsi qu'à
        l'adresse de supervision ci-dessous. Laissez le champ vide pour n'envoyer la copie qu'à l'expéditeur.
      </p>
      <label className="text-xs font-semibold text-muted">Adresse de supervision (copie cachée)</label>
      <input
        data-testid="email-copie-input"
        className="nx-input mt-1"
        type="email"
        placeholder="sales@naxium.net"
        value={valeur}
        onChange={(e) => setValeur(e.target.value)}
        disabled={!loaded}
      />
      {err && <p className="mt-2 text-xs text-red-600" data-testid="email-copie-err">{err}</p>}
      {msg && <p className="mt-2 text-xs text-green" data-testid="email-copie-ok">{msg}</p>}
      <div className="mt-3">
        <button data-testid="email-copie-save-btn" className="nx-btn-primary" disabled={busy || !loaded} onClick={save}>
          {busy ? "Enregistrement…" : "Enregistrer"}
        </button>
      </div>
    </div>
  );
}

export default function Parametrage() {
  const [tab, setTab] = useState("produits");
  return (
    <div data-testid="parametrage-page">
      <h1 className="mb-4 text-2xl font-extrabold text-green">Paramétrage</h1>
      <Tabs
        tabs={[
          { key: "produits", label: "Produits" },
          { key: "entites", label: "Entités de facturation" },
          { key: "grille", label: "Grille KPAX & SLA" },
          { key: "taux", label: "Taux de change" },
          { key: "numerotation", label: "Numérotation" },
          { key: "emails", label: "Emails" },
          { key: "listes", label: "Listes de valeurs" },
          { key: "users", label: "Utilisateurs" },
        ]}
        active={tab}
        onChange={setTab}
      />
      {tab === "produits" && <Produits />}
      {tab === "entites" && <Entites />}
      {tab === "grille" && <Grille />}
      {tab === "taux" && <Taux />}
      {tab === "numerotation" && <Numerotation />}
      {tab === "emails" && <EmailCopie />}
      {tab === "listes" && <ListesValeurs />}
      {tab === "users" && <Users />}
    </div>
  );
}
